import React from "react";

// Safe empty state shown when a store has no landable feature for the current
// user — e.g. scheduling is disabled and every other module the user could
// land on is also off. It is intentionally static: it fetches nothing and
// mounts no feature surface, so it can never expose a disabled feature's data.
const NoEnabledFeatures = () => {
  return (
    <div
      className="flex min-h-[70vh] items-center justify-center p-6"
      data-no-enabled-features="true"
    >
      <div className="w-full max-w-md bg-white rounded-2xl shadow-md p-8 text-center">
        <img
          src="https://rightworkpublic.s3.us-west-1.amazonaws.com/logo_name.png"
          alt="Rightwork"
          className="h-7 mx-auto mb-6"
        />
        <h2 className="text-xl font-semibold text-slate-900 mb-2">
          No features are enabled
        </h2>
        <p className="text-slate-500 leading-relaxed">
          There are no features turned on for this store yet. Please contact your
          administrator to enable the modules you need.
        </p>
      </div>
    </div>
  );
};

export default NoEnabledFeatures;
